import UTILS from "../../utils";
import PropTypes from "prop-types";

const FieldRepeat = ({
                         field,
                         form: {touched, errors, setFieldValue}
                     }) => {

    const handleRepeatChange = () => {
        const options = UTILS.virtualClass.repeatOptions();
        let index = options.findIndex(option => option === field.value);

        ++index;

        if(index > 2)
            index = 0;

        setFieldValue("repeat", options[index])
    }
    return (
        <p className={"px-6 py-4 mb-6 shadow rounded-lg flex items-center cursor-pointer"} onClick={handleRepeatChange}>
            <i className="icon icon-repeat text-zinc-400 pr-7"></i>
            {field.value}
            {
                touched[field.name] && errors[field.name] &&
                <p className={'text-red-500 '}>{errors[field.name]}</p>
            }
        </p>
    )
}

export default FieldRepeat;

FieldRepeat.propTypes = {
    field: PropTypes.object,
    form: PropTypes.object,
}

